<template>
  <div :class="{ foot: true, ar: $i18n.locale === 'AR', regular: true }">
    <div class="container">
      <div class="logo"></div>
      <div class="links" :class="isMobile ? 'mobile' : ''">
        <a class="link" target="_blank" :href="$utils.getTermsOfServiceUrl($i18n.locale)">{{
          $t('foot.service')
        }}</a>
        <a class="link" target="_blank" :href="$utils.getPrivacyPolicyUrl($i18n.locale)">{{
          $t('foot.policy')
        }}</a>
        <a class="link" target="_blank" :href="$utils.getPaymentTermsUrl($i18n.locale)">{{
          $t('foot.payment')
        }}</a>
        <span class="link" @click="handleCookie">{{ $t('cookie.titleCustom') }}</span>
      </div>
      <div class="copyrigt">{{ footerText }}</div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  data() {
    return {
      footerText: '',
    }
  },
  computed: {
    ...mapState({
      isMobile: (state) => state.app.isMobile,
      isNewWebsite: (state) => state.app.isNewWebsite,
    }),
  },
  created() {
    if (
      process.env.VUE_APP_GAME_ID == 20317 ||
      process.env.VUE_APP_GAME_ID == 20349 ||
      process.env.VUE_APP_GAME_NAME === 'home_ru'
    ) {
      this.footerText = '©2026 Echofun Interactive Limited'
    } else {
      this.footerText = 'Copyright © Century Games. All Rights Reserved.'
    }
  },
  methods: {
    handleCookie() {
      this.$root.Bus.$emit('showCookieSettings')
    },
  },
}
</script>

<style lang="less" scoped>
.foot {
  position: relative;
  flex-shrink: 0;
  margin-top: 20px;
  overflow: hidden;
  background: #374863;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  padding: 19px 0 16px;
  .container {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    color: #8d98ae;
    font-size: 12px;
    line-height: 24px;
  }
  .logo {
    width: 100%;
    height: 34.5px;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
  }
  .links {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 12px;
    &.mobile {
      flex-direction: column;
      line-height: 26px;
      margin: 7px 0 2px;
    }
    .link {
      margin: 0 7px;
      cursor: pointer;
    }
  }
}
</style>
